import { TripLegAddress } from '../../data/models/reservation.model';

class AddressTransformUtils {
  public getDisplayAddress(address?: TripLegAddress): string {
    if (address?.addressLine1) {
      return `${address.addressLine1}${
        address.addressLine2
          ? `
        ${address.addressLine2}`
          : ''
      },
      ${address.city}, ${address.stateCode}, ${address.zipCode.trim().substring(0, 5)}`;
    }
    return '';
  }
}

const addressTransformUtils = new AddressTransformUtils();
export default addressTransformUtils;
